import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import buildConfig from 'json-loader!appRoot/build.config.json';

var versionName = ApplicationFeatures.getAllFeatures().versionName;

/**
 * Provides entry point used to access xcenter (depends on the environment and versionName for the app)
 * @param {Boolean} IS_DISTRIBUTION_BUILD - flag to separate /app (Dev) and distribution builds
 * @returns {String}
 */
export default (function (IS_DISTRIBUTION_BUILD) {
    var applicationPath = ''; // development environment redirect direct to xcenter without app name

    if (IS_DISTRIBUTION_BUILD) {
        // dist environment
        if (buildConfig.releaseName) {
            // one releaseName
            applicationPath = '/' + buildConfig.releaseName;
        } else {
            // version dependent releaseName
            var versionData = buildConfig.versions.filter(function (version) {
                return version.features.versionName === versionName;
            })[0];
            applicationPath = '/' + versionData.releaseName;
        }
    }

    return applicationPath;
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-platform-js/entryPoint/GetXcenterEntryPoint.js
// module id = 1355
// module chunks = 0